module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "chat-item"
  }, [_c('div', {
    staticClass: "message"
  }, [_c('img', {
    staticClass: "askerIcon",
    attrs: {
      "src": _vm.pictureUrl
    },
    on: {
      "click": function($event) {
        _vm.openPersonCard(_vm.person)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-span"
  }, [_c('div', {
    staticClass: "message-user-name"
  }, [(_vm.person) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.openPersonCard(_vm.person)
      }
    }
  }, [_vm._v(_vm._s(_vm.person.firstName) + " " + _vm._s(_vm.person.lastName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "message-text"
  }, [_vm._v(_vm._s(_vm.question.question))])]), _vm._v(" "), _c('div', {
    staticClass: "message-bottom-menu"
  }, [_c('span', {
    staticClass: "message-timestamp"
  }, [_vm._v(_vm._s(_vm.getTimestamp))]), _vm._v(" "), _c('span', {
    staticClass: "message-reply-button",
    on: {
      "click": function($event) {
        _vm.viewReplies()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Reply')))]), _vm._v(" "), (_vm.question.props !== null) ? _c('span', {
    staticClass: "message-comments",
    on: {
      "click": function($event) {
        _vm.toggleReplies()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$tc('str.CommentsCount', _vm.isPlurial, {
    count: Object.keys(_vm.question.props).length
  })) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "message-likes"
  }, [(!_vm.question.voted) ? _c('i', {
    staticClass: "fa fa-thumbs-o-up",
    on: {
      "click": function($event) {
        _vm.likeQuestion()
      }
    }
  }, [_vm._v(" ")]) : _c('i', {
    staticClass: "fa fa-thumbs-up"
  }, [_vm._v(" ")]), _vm._v("\n                " + _vm._s(_vm.question.votes) + "\n            ")])])]), _vm._v(" "), (_vm.showReplies) ? _c('div', {
    staticClass: "message-reply-section"
  }, [_c('ul', {
    staticClass: "message-replies"
  }, _vm._l((_vm.question.replies), function(reply, index) {
    return _c('questionreplybox', {
      key: index,
      staticClass: "message-reply",
      attrs: {
        "reply": reply,
        "person": _vm.getPerson(index)
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "message-reply-text"
  }, [(_vm.user.pictureUrl) ? _c('img', {
    staticClass: "message-reply-icon",
    attrs: {
      "src": _vm.user.pictureUrl
    }
  }) : _c('img', {
    staticClass: "message-reply-icon",
    attrs: {
      "src": require("../../assets/icons/anonymous.svg")
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyText),
      expression: "replyText"
    }],
    ref: "replyInput",
    staticClass: "message-reply-text-box",
    attrs: {
      "maxlength": "500",
      "placeholder": _vm.$t('str.EnterYourReplyHere')
    },
    domProps: {
      "value": (_vm.replyText)
    },
    on: {
      "focus": _vm.replyFocus,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.replyToQuestion($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "message-reply-submit",
    attrs: {
      "src": require("../../assets/icons/enter.svg")
    },
    on: {
      "click": _vm.replyToQuestion
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92287bf8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/QuestionBox.vue
// module id = 485
// module chunks = 0